import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../../../../projects/vendors/src/lib/services/api-base.service';
import { UserMeResponse } from '../../@domain/user-details.model';
import { ApiEnum } from '../enum/api.enum';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private apiBaseService: ApiBaseService) { }

  getUserDetails(): Observable<UserMeResponse> {
    return this.apiBaseService.GET<UserMeResponse>([ApiEnum.Me], false, false);
  }
}

